<section *ngIf="data" class="license-panel-v3">
  <h2 *ngIf="data?.title?.value" class="license-panel-v3__title" #titleEl>
    {{ data.title.value }}
  </h2>
  <div
    *ngIf="data?.description?.value"
    [innerHTML]="data.description.value | safe"
    class="license-panel-v3__description"
    #descriptionEl
  ></div>

  <div class="license-panel-v3__items-wrapper">
    <ngx-simplebar #scrollEl [options]="scrollBarOptions" class="simplebar-custom">
      <ul *ngIf="data?.items?.value" class="license-panel-v3__items">
        <li
          *ngFor="let item of data.items.value"
          [class.focused-license]="item.focused?.value" 
          class="license-panel-v3__item"
        >
          <app-license-panel-item [item]="item"></app-license-panel-item>
        </li>
      </ul>
    </ngx-simplebar>
  </div>

  <div
    *ngIf="data?.textAfter?.value"
    [innerHTML]="data.textAfter.value | safe"
    class="license-panel-v3__text-after"
    #textAfterEl
  ></div>
  <div *ngIf="data?.link?.value" class="license-panel-v3__link-after">
    <a [href]="data.link.value.url">{{ data.link.value.name }}</a>
  </div>
  <div
    *ngIf="data?.linkToComparisonPage?.value"
    class="license-panel-v3__link-after license-panel-v3__link-after--desktop"
  >
    <a
      (click)="navigateToAnchor(data.linkToComparisonPage.value.url)"
      target="{{ data.linkToComparisonPage.value.target || '_self' }}"
      >{{ data.linkToComparisonPage.value.name }}</a
    >
  </div>
  <div
    *ngIf="data?.linkToComparisonDocument?.value"
    class="license-panel-v3__link-after license-panel-v3__link-after--mobile"
  >
    <a
      [href]="data.linkToComparisonDocument.value.url"
      target="{{ data.linkToComparisonDocument.value.target || '_self' }}"
      >{{ data.linkToComparisonDocument.value.name }}</a
    >
  </div>
</section>
